import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {
  isOK = false;

  loading: boolean = false;
  perguntas: Array<pergunta> = [];
  pesquisa: number = 0;

  options1!: Options;

  constructor(public userService: UserService, private router: Router, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('25')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.options1 = {
      allowClear: true,
      placeholder: 'Filtrar por Categoria',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-categoria',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
    };

    this.fetchArquivos();
  }

  fetchArquivos() {
    this.loading = true;
    this.userService.arquivosList().subscribe(
      (res: any) => {
        res.forEach(element => {
          this.perguntas.push({
            id: 'p' + element.id,
            categoria: element.categoria,
            pergunta: element.titulo,
            resposta: '',
            loading: false
          })
        });
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.loading = false
      },
      () => this.loading = false
    )
  }

  fetchArquivo(id: string) {
    const msgIndex = this.perguntas.findIndex(element => element.id === id);

    this.perguntas[msgIndex].loading = true;
    this.userService.fetchArquivo(Number(id.replace('p', ''))).subscribe(
      (res: any) => {
        this.perguntas[msgIndex].resposta = this.sanitized.bypassSecurityTrustHtml(res.resposta) as string;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.perguntas[msgIndex].loading = false
      },
      () => this.perguntas[msgIndex].loading = false
    )
  }

  baixarArquivo(ele, id: string) {
    ele.disabled = true;
    ele.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
    this.userService.baixarArquivo(Number(id.replace('p', ''))).subscribe(
      (res: any) => {
        window.open(res.link, '_blank')!.focus();
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        ele.disabled = false;
        ele.innerHTML = '<i class="bi bi-download me-2"></i>Baixar Arquivo';
      },
      () => {
        ele.disabled = false;
        ele.innerHTML = '<i class="bi bi-download me-2"></i>Baixar Arquivo';
      }
    )
  }
}

export interface pergunta {
  id: string;
  categoria: number;
  pergunta: string;
  resposta: string;
  loading: boolean;
}
